// extracted by mini-css-extract-plugin
module.exports = {"logo":"_3bc8430"};